import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";

let loading, unitEnrolment, activity;

function loadUnit() {
    loading = true;
    Requester.get(Gateway.admin + "units/enrolments/" + unitEnrolment.id)
        .then(function (result) {
            if (result && result.properties.data) {
                const json = JSON.parse(result.properties.data);
                if (json.interactions.childArray)
                    activity = Object.values(json.interactions.childArray);
                else
                    activity = Object.values(json.interactions);
            }
        }).catch(function (error) {
        Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
    }).finally(function () {
        loading = false;
    });
}

function formatValue(text) {
    return text.replaceAll("urn:scormdriver:", "").replaceAll(/_|%20/g, " ").split("[,]").join(", ");
}

// Latency comes through as either a SCORM 1.2 timespan (HHHH:MM:SS.SS)
// or a SCORM 2004 ISO 8601 duration (P[nY][nM][nD]T[nH][nM][nS]).
function latencyToSeconds(latency) {
    const text = String(latency).trim();

    if (text.includes(":")) {
        const parts = text.split(":").map(parseFloat);
        while (parts.length < 3) parts.unshift(0);
        const [hours, minutes, seconds] = parts.slice(-3);
        return (hours * 3600) + (minutes * 60) + seconds;
    }

    const match = text.match(/^P(?:(\d+(?:\.\d+)?)Y)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)D)?(?:T(?:(\d+(?:\.\d+)?)H)?(?:(\d+(?:\.\d+)?)M)?(?:(\d+(?:\.\d+)?)S)?)?$/i);
    if (match) {
        const [years, months, days, hours, minutes, seconds] = match.slice(1).map(function (value) {
            return value ? parseFloat(value) : 0;
        });
        return (years * 31536000) + (months * 2592000) + (days * 86400) + (hours * 3600) + (minutes * 60) + seconds;
    }

    return parseFloat(text.replace(/[^0-9.]+/g, ""));
}

function formatLatency(latency) {
    if (latency === undefined || latency === null || latency === "") return "";

    const total = latencyToSeconds(latency);
    if (isNaN(total)) return "";

    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const roundedSeconds = total < 60 ? Math.round(seconds * 10) / 10 : Math.round(seconds);

    const parts = [];
    if (days) parts.push(days + "d");
    if (hours) parts.push(hours + "h");
    if (minutes) parts.push(minutes + "m");
    if (roundedSeconds || !parts.length) parts.push(roundedSeconds + "s");
    return parts.join(" ");
}

const Modal_Scorm_Activity = {
    oninit: function (vnode) {
        unitEnrolment = vnode.attrs.unitEnrolment;
        activity = [];
        loadUnit();
    },
    view: function () {
        return [
            !loading ?
                activity && activity.length > 0 ? [
                    m(".table-wrapper", [
                        m("table.full-width fixed-table ellipsis activity-table no-hover", [
                            m("thead",
                                m("tr", [
                                    m("th", i18n.t("question")),
                                    m("th", i18n.t("correct_response")),
                                    m("th", i18n.t("learner_response")), undefined,
                                    m("th", {style: "width: 10%;"}, i18n.t("time")),
                                    m("th", {style: "width: 10%;"}, i18n.t("result"))
                                ])
                            ),
                            m("tbody", activity.map(function (inter) {
                                const correctResponses = inter.correct_responses.childArray || Object.values(inter.correct_responses);
                                return [
                                    m("tr.break-word", [
                                        m("td", inter.description ? formatValue(inter.description) : inter.id),
                                        m("td", correctResponses.map(function (res) {
                                            return [
                                                res.pattern ? formatValue(res.pattern) : ""
                                            ]
                                        })),
                                        m("td", inter.learner_response ? formatValue(inter.learner_response) : inter.student_response ? formatValue(inter.student_response) : ""),
                                        m("td", formatLatency(inter.latency)),
                                        m("td", inter.result)
                                    ])
                                ];
                            }))
                        ])
                    ])
                ] : m(".text-gray padding", i18n.t("no_activity"))
                : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
};

export default Modal_Scorm_Activity;
